import { unreportedAssetPages } from './unreportedAssetPages';

export default {
  title: 'Other assets',
  pages: unreportedAssetPages,
};
